var _a;
import { UrlMappingsKeys } from '../url-mappings-keys';
export var bookingsMapping = (_a = {},
    _a[UrlMappingsKeys.BOOKINGS_SERVICE] = {
        variables: ['slug'],
        required: ['slug'],
        defaultPrefix: 'service-page',
    },
    _a);
//# sourceMappingURL=bookings.js.map